//
//
//
//
//
//
//
//
//
//
//

import orderList from './list'
export default {
    components: {
        orderList
    },
    data() {
        return {

        }
    },
    methods: {
        goBack() {
            this.$router.push("/mine");
        }
    },
    mounted() {
        
    }
}



// WEBPACK FOOTER //
// ./src/components/order/refund.vue